enum DepositByProductEntryPoints {
  getCollectionPicking = '/api/inventory-management/picking/list',
  addPicking = '/api/inventory-management/picking/add/{id}',
  editPicking = '/api/inventory-management/picking/{id}',
}

export default DepositByProductEntryPoints;
